import { FormInputFieldsFragment } from 'types/generated';
import { getOr } from '@/utils/options';
import KennitalaInput from '../common/KennitalaInput';
import PhonenumberInput from '../common/PhoneNumberInput';
import TextInput from 'components/src/textInput/TextInput';

type FormInputProps = {
  data: FormInputFieldsFragment;
  setError: React.Dispatch<React.SetStateAction<boolean>>;
  onChange?: (value: string) => void;
};

const FormInput = ({ data, setError, onChange }: FormInputProps) => {
  if (!(data.title && data.id)) return null;

  return (
    <div className="grid grid-flow-row">
      {data.inputType === 'kennitala' ? (
        <KennitalaInput
          id={data.id}
          name={getOr(data.name, '')}
          label={data.title}
          setValidationError={setError}
          placeholder={getOr(data.placeholder, '')}
          onChange={onChange}
        />
      ) : data.inputType === 'tel' ? (
        <PhonenumberInput
          id={data.id}
          name={getOr(data.name, '')}
          label={data.title}
          placeholder={getOr(data.placeholder, '')}
          onChange={onChange}
        />
      ) : (
        <TextInput
          label={data.title}
          id={data.id}
          name={getOr(data.name, '')}
          placeholder={getOr(data.placeholder, '')}
          type={data.inputType as React.InputHTMLAttributes<HTMLInputElement>['type']}
          onChange={onChange}
        />
      )}
    </div>
  );
};

export default FormInput;
